export const clearReducer = (actionName: string) => ({
  type: actionName,
  payload: null,
});
